import Api from '@/api'
import { CacheGetOtherUserInfo, CacheGetPDFUserInfo, CacheSetOtherUserInfo, CacheSetPDFUserInfo } from '../utils/cache'

const STATE_DATA_STRUCT = {
  uid: '', // pdf uid
  token: '' // pdf token
}

const loginType = 10

export default {
  namespaced: true,

  state: {
    pdfUserInfo: { ...STATE_DATA_STRUCT }, // pdf的token仅存在87400秒
  },

  actions: {
    // pdf登录
    login ({ dispatch, commit }, info) {
      const otherUserInfo = CacheGetOtherUserInfo() // 外部用户信息， 素材站的token过期时间是半年
      const PDFUserInfo = CacheGetPDFUserInfo()

      if (otherUserInfo?.token === info.token && PDFUserInfo?.token) { // 如果等于，还要判断pdf的token是否有效，否则都需要重新登录
        commit('setPdfUserInfo', PDFUserInfo)
        dispatch('refresh') // 刷新一次用户信息，防止支付等操作
        return
      }
      CacheSetOtherUserInfo(info)

      Api.get('fileConvert').login({ data: { login_type: loginType, open_id: info.uid, token: info.token } }).then((res) => {
        const pdfUser = res?.data || {}
        if (pdfUser?.uid) {
          commit('setPdfUserInfo', { uid: pdfUser.uid, token: pdfUser.token })
        }
      })
    },

    logout ({ commit }) {
      return Api.get('fileConvert').logout().finally(() => {
        commit('logout')
      })
    },

    // 刷新用户
    refresh ({ commit, state, rootState }) {
      return Api.get('fileConvert').refresh({ data: { login_type: loginType, open_id: rootState.userInfo.uid, token: rootState.userInfo.token } }).then((res) => {
        if (res?.data?.token) {
          commit('setPdfUserInfo', { uid: state.pdfUserInfo.uid, token: res.data.token }) // 该接口不返回uid
        }
      })
    }
  },

  mutations: {
    // 用户信息存到store
    setPdfUserInfo (state, userInfo) {
      if (userInfo) {
        state.pdfUserInfo = { ...state.pdfUserInfo, ...userInfo }
        CacheSetPDFUserInfo(state.pdfUserInfo)
      }
    },
    // 登出
    logout (state) {
      state.pdfUserInfo = { ...STATE_DATA_STRUCT }
      CacheSetPDFUserInfo(state.pdfUserInfo)
    }
  },

  getters: {
    PDFIsLogined (state) {
      const { uid, token } = state.pdfUserInfo

      if (uid && token) return true

      return false
    }
  }
}
